export const GET_BOM_RAW_MATERIALS = 'GET_BOM_RAW_MATERIALS';
export const GET_BOM_RAW_MATERIALS_SUCCESS = 'GET_BOM_RAW_MATERIALS_SUCCESS';
export const GET_BOM_RAW_MATERIALS_FAILED = 'GET_BOM_RAW_MATERIALS_FAILED';

export const ADD_BOM_RAW_MATERIALS = 'ADD_BOM_RAW_MATERIALS';
export const ADD_BOM_RAW_MATERIALS_SUCCESS = 'ADD_BOM_RAW_MATERIALS_SUCCESS';
export const ADD_BOM_RAW_MATERIALS_FAILED = 'ADD_BOM_RAW_MATERIALS_FAILED';

export const UPDATE_BOM_RAW_MATERIALS = 'UPDATE_BOM_RAW_MATERIALS';
export const UPDATE_BOM_RAW_MATERIALS_SUCCESS = 'UPDATE_BOM_RAW_MATERIALS_SUCCESS';
export const UPDATE_BOM_RAW_MATERIALS_FAILED = 'UPDATE_BOM_RAW_MATERIALS_FAILED';

export const DELETE_BOM_RAW_MATERIALS = 'DELETE_BOM_RAW_MATERIALS';
export const DELETE_BOM_RAW_MATERIALS_SUCCESS = 'DELETE_BOM_RAW_MATERIALS_SUCCESS';
export const DELETE_BOM_RAW_MATERIALS_FAILED = 'DELETE_BOM_RAW_MATERIALS_FAILED'; 

export const ISSUE_RAW_MATERIAL = 'ISSUE_RAW_MATERIAL';
export const ISSUE_RAW_MATERIAL_SUCCESS = 'ISSUE_RAW_MATERIAL_SUCCESS';
export const ISSUE_RAW_MATERIAL_FAILED = 'ISSUE_RAW_MATERIAL_FAILED'; 

export const LINK_BOM = 'LINK_BOM';
export const LINK_BOM_SUCCESS = 'LINK_BOM_SUCCESS';
export const LINK_BOM_FAILED = 'LINK_BOM_FAILED'; 

export const UNLINK_BOM = 'UNLINK_BOM';
export const UNLINK_BOM_SUCCESS = 'UNLINK_BOM_SUCCESS';
export const UNLINK_BOM_FAILED = 'UNLINK_BOM_FAILED';